import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { WorkspaceDomainDTO } from 'features/workspace/api/types/workspaceDTO'
import { WorkspaceAlert } from 'features/workspace/types/workspaceAlert'
import { WorkspaceDomainSubRow, WorkspaceForTable, WorkspaceSortBy } from '../types'
import { WorkspaceForTableDTO, WorkspaceSortByDTO } from './types'

export const mapFromDTO = (from: WorkspaceForTableDTO): WorkspaceForTable =>
  mapDTO<WorkspaceForTableDTO, WorkspaceForTable>({ from }).transform(
    (dto: WorkspaceForTableDTO): WorkspaceForTable => {
      const { alerts, domains, updatedAt } = dto

      return {
        ...dto,
        alerts: alertsFromDTO<WorkspaceAlert>(alerts),
        domains: domains.length,
        subRows: domains.map(
          ({ alerts, id, name }: WorkspaceDomainDTO): WorkspaceDomainSubRow => ({
            alerts: alertsFromDTO<DomainAlert>(alerts),
            domains: name,
            id,
          }),
        ),
        updatedAt: new Date(updatedAt),
      }
    },
  )

export const sortToDTO = (sort: SortInput<WorkspaceSortBy>): SortInput<WorkspaceSortByDTO> => {
  const { by } = sort

  if (by === 'name') {
    return { ...sort, by: 'workspaceName' }
  } else {
    return { ...sort, by }
  }
}
